// extracted by mini-css-extract-plugin
export default {"menuButton":"MenuButton_menuButton__quf-C","buttonText":"MenuButton_buttonText__RbUNo","buttonIcon":"MenuButton_buttonIcon__C55xl"};